import { DeepPartial, DeepReadonly } from 'ts-essentials';
import { DataType, DeltaOf, IDataModel, IPresentationDataModel, ISlideProps } from '@tencent/slide-sdk-model';
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { ElementBaseSdkTypeV3 } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { invertMap } from '@src/slide/infrastructure/module/independent/object/map-invert';
import { ADD_ON_MODE_MAP } from '@src/slide/domain/ui-model/converter/node-property/sdk-ui-enum-map/data-type';

export class DataModelCommonConverter {
    /**
     * IDataModel通用字段sdk -> ui 映射
     * @param sdkData
     * @param uiData
     */
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepPartial<ElementBaseSdkTypeV3 | ISlideProps | IPresentationDataModel>,
        uiData: IBaseModel,
    ): void {
        if (sdkData?.id !== undefined) {
            uiData.id = sdkData.id;
            uiData.uniqueID = sdkData.id;
        }
    }

    public static convertPartialDataFromUiToSdk(
        uiData: DeepReadonly<DeepPartial<IBaseModel>>,
        sdkData: DeltaOf<IDataModel>,
    ): void {
        if (uiData.id !== undefined) {
            sdkData.id = uiData.id;
        }
        if (uiData.type !== undefined) {
            sdkData.type = DataModelCommonConverter.getSdkTypeByUiType(uiData.type);
        }
    }

    private static getSdkTypeByUiType(uiType: UIModelType): DataType {
        return invertMap(ADD_ON_MODE_MAP).get(uiType) ?? DataType.Shape;
    }
}
